// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL Reports API (nestjs)
 * API for reports in WL
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentLanguageGemResponseDto } from './StudentLanguageGemResponseDto'
import {
  StudentLanguageGemResponseDtoFromJSON,
  StudentLanguageGemResponseDtoFromJSONTyped,
  StudentLanguageGemResponseDtoToJSON,
} from './StudentLanguageGemResponseDto'

/**
 *
 * @export
 * @interface WordWallsControllerGetStudentLanguageGem200Response
 */
export interface WordWallsControllerGetStudentLanguageGem200Response {
  /**
   *
   * @type {Array<StudentLanguageGemResponseDto>}
   * @memberof WordWallsControllerGetStudentLanguageGem200Response
   */
  data: Array<StudentLanguageGemResponseDto>
  /**
   *
   * @type {number}
   * @memberof WordWallsControllerGetStudentLanguageGem200Response
   */
  total: number
  /**
   *
   * @type {number}
   * @memberof WordWallsControllerGetStudentLanguageGem200Response
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof WordWallsControllerGetStudentLanguageGem200Response
   */
  itemsPerPage: number
  /**
   * Additional metadata
   * @type {object}
   * @memberof WordWallsControllerGetStudentLanguageGem200Response
   */
  meta?: object
}

/**
 * Check if a given object implements the WordWallsControllerGetStudentLanguageGem200Response interface.
 */
export function instanceOfWordWallsControllerGetStudentLanguageGem200Response(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'data' in value
  isInstance = isInstance && 'total' in value
  isInstance = isInstance && 'page' in value
  isInstance = isInstance && 'itemsPerPage' in value

  return isInstance
}

export function WordWallsControllerGetStudentLanguageGem200ResponseFromJSON(
  json: any,
): WordWallsControllerGetStudentLanguageGem200Response {
  return WordWallsControllerGetStudentLanguageGem200ResponseFromJSONTyped(
    json,
    false,
  )
}

export function WordWallsControllerGetStudentLanguageGem200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): WordWallsControllerGetStudentLanguageGem200Response {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(
      StudentLanguageGemResponseDtoFromJSON,
    ),
    total: json['total'],
    page: json['page'],
    itemsPerPage: json['itemsPerPage'],
    meta: !exists(json, 'meta') ? undefined : json['meta'],
  }
}

export function WordWallsControllerGetStudentLanguageGem200ResponseToJSON(
  value?: WordWallsControllerGetStudentLanguageGem200Response | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(StudentLanguageGemResponseDtoToJSON),
    total: value.total,
    page: value.page,
    itemsPerPage: value.itemsPerPage,
    meta: value.meta,
  }
}
